// @avantia common-code
import {
  addToWindowRef,
  getEnumFlags,
  getFunctionName,
  MicroTimer,
  toEnumFlags
} from '@avantia/client-and-server-utilities';
import { createIsolatedPackageLoggerWithFlags } from '@avantia/logging-and-errors';
import { HpClientDebugFlags } from './clientDebugFlags';

const log = createIsolatedPackageLoggerWithFlags<HpClientDebugFlags>(
  'HpClientDebugFlags',
  HpClientDebugFlags.None,
  HpClientDebugFlags.All
);

const {
  critical: logCritical,
  debug: logDebug,
  error: logError,
  getFlags: getLoggerFlagsForEngineClient,
  getLogger: getLoggerForEngineClient,
  info: logInfo,
  notice: logNotice,
  setFlags: setLoggerFlagsForEngineClient,
  setLogger: setLoggerForEngineClient,
  warn: logWarning
} = log;

export {
  getLoggerFlagsForEngineClient,
  getLoggerForEngineClient,
  logCritical,
  logDebug,
  logError,
  logInfo,
  logNotice,
  logWarning,
  setLoggerFlagsForEngineClient,
  setLoggerForEngineClient
};

export function displayTimeTaken(description: string, timer: MicroTimer): void {
  logInfo(`${description}: took ${timer.elapsedTimeAsString()}`, HpClientDebugFlags.TimeTaken);
}

export function recordElapsedTime<ResultT>(description: string, action: () => ResultT): ResultT {
  const timer = new MicroTimer();
  const res = action();
  displayTimeTaken(description, timer);
  return res;
}

export function recordElapsedTimeOfFunc<PropsT, ResultT>(
  description: string,
  func: (props: PropsT) => ResultT,
  props: PropsT
): ResultT {
  const timer = new MicroTimer();
  const res = func.call(undefined, props);
  const funcName = getFunctionName(func);
  if (description !== funcName) {
    // the function name will be minified in production, so we need both
    description = `${description} (${funcName})`;
  }

  displayTimeTaken(description, timer);
  return res;
}

export function setDebugFlags(debugWhich: HpClientDebugFlags | string): string[] {
  if (typeof debugWhich === 'number') {
    log.setFlags(debugWhich);
  } else {
    log.setFlags(toEnumFlags(debugWhich as string, HpClientDebugFlags as any));
  }

  return getDebugFlags();
}

export function getDebugFlags(mode?: HpClientDebugFlags): string[] {
  return getEnumFlags(mode === undefined ? log.getFlags() : mode, HpClientDebugFlags as any);
}

addToWindowRef({ setDebugFlags, getDebugFlags });
